import { useState } from "react";
import speakJournalSvg from "../../../../appAssets/svg/speak_journal.svg";
import writeJournalSvg from "../../../../appAssets/svg/write_journal.svg";
import { InputMethod, JOURNAL_STRINGS } from "../../types";
import "./DisplayPopUp.scss";

interface DisplayPopUpProps {
  onContinue: (method: InputMethod) => void;
  onClose: () => void;
}

function DisplayPopUp({ onContinue, onClose }: DisplayPopUpProps) {
  const [selected, setSelected] = useState<InputMethod>("speak");

  const renderOption = (method: InputMethod, icon: string) => (
    <button
      key={method}
      type="button"
      className={`journal-pop__choice${selected === method ? " journal-pop__choice--active" : ""}`}
      onClick={() => setSelected(method)}
      aria-label={method}
    >
      <img src={icon} alt={method} className="journal-pop__choice-img" />
      <span className="journal-pop__choice-label">
        {JOURNAL_STRINGS.iWantTo}
        <strong>{method}</strong>
      </span>
    </button>
  );

  return (
    <div className="journal-pop" onClick={onClose}>
      <div className="journal-pop__card" onClick={(e) => e.stopPropagation()}>
        <h2 className="journal-pop__title">{JOURNAL_STRINGS.howToJournal}</h2>

        <div className="journal-pop__choices">
          {renderOption("speak", speakJournalSvg)}
          {renderOption("write", writeJournalSvg)}
        </div>

        <button
          type="button"
          className="journal-pop__continue"
          onClick={() => onContinue(selected)}
        >
          {JOURNAL_STRINGS.okay}
        </button>
      </div>
    </div>
  );
}

export default DisplayPopUp;
